// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import eh_panBtn_click from "../eventHandlers/eh_panBtn_click.js";

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "init_panBtn", inline: true };
const loggerMsgs = {
  initStart: ["init. panBtn"],
  initSuccess: ["init. panBtn", "init. success"],
  noValidDOMEl: ["init. panBtn", "no valid DOM element provided"],
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_panBtn() {
  // Setup...
  const { panBtn, tooltip_panBtn } = this.ref;
  this.logger("init", loggerMsgs.initStart, "action", logArgs);

  // Guard...
  if (!this.validate_refEl(panBtn)) return this.cancel_featInit(loggerMsgs.noValidDOMEl);

  // Event hdl...
  panBtn.addEventListener("click", eh_panBtn_click.bind(this));

  // Init. tooltip...
  this.init_tooltip(panBtn, tooltip_panBtn);

  // Conclude...
  this.logger("init", loggerMsgs.initSuccess, "success", logArgs);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
